import Swiper from 'swiper/bundle';

class HeroSlider {
    constructor() {
        this.components = document.querySelectorAll('.m-hero-slider');

        this.components.forEach((component) => {
            this.init(component);
        });
    }

    init(component) {
        const swiper = component.querySelectorAll('.swiper');

        new Swiper(swiper[0], {
            slidesPerView: 1,
            speed: 1000,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }
}

export default HeroSlider;
